export default __webpack_public_path__ + "static/media/clientsBanner.f72ce31f.jpg";